<template>
  <div v-if="!loading" class="login-page" :class="[isMobile && 'is-mobile', accountType === ACCOUNT_TYPE.CANDIDATE && 'is-candidate', showCustomFooterNavigation && 'has-custom-footer']" :style="customStyle">
    <!-- <img class="background-image right-top" src="~@/assets/login/right_top_bg.png" />
    <img class="background-image left-bottom" src="~@/assets/login/left_bottom_bg.png" /> -->
    <div v-if="showTopAndBottomBackgroundImage" class="background-image right-top"></div>
    <div v-if="showTopAndBottomBackgroundImage" class="background-image left-bottom"></div>
    <div v-if="isMobile" v-clickoutside="closeAccountTypeList" class="account-type-selector mobile-selector">
      <div class="account-type-container" @click="onAccountTypeLabelClick">
        <span class="account-type">{{ accountTypeLabel }}</span>
        <i class="dropdown-icon el-icon-arrow-down"></i>
      </div>
      <div v-show="showAccountTypeList" class="dropdown-list">
        <div
          v-for="(val, key) in accountTypeList"
          class="dropdown-item"
          :key="key"
          @click="onAccountTypeClick(val)"
        >{{ $t(`login.common.accountType.${key}`) }}</div>
      </div>
    </div>
    <div v-else class="header" :class="showHolidayLogo && 'has-holiday-logo'">
      <img v-if="showHolidayLogo" class="holiday-icon" :class="holidayIconClass" :src="holidayIcon">
      <PersonalCommonHeader
        v-if="companyId"
        class="common-header"
        isLoginPage
        :companyId="companyId"
        :company="company"
        :customPage="customPage"
        :showHolidayLogo="showHolidayLogo"
        @changeLanguage="handleChangeLanguage"
      >
        <template #userMenu>
          <div class="navigation-item">
            <div v-clickoutside="closeAccountTypeList" class="account-type-selector">
              <div class="account-type-container" @click="onAccountTypeLabelClick">
                <span class="account-type">{{ accountTypeLabel }}</span>
                <i class="dropdown-icon el-icon-arrow-down"></i>
              </div>
              <div v-show="showAccountTypeList" class="dropdown-list">
                <div
                  v-for="(val, key) in accountTypeList"
                  class="dropdown-item"
                  :key="key"
                  @click="onAccountTypeClick(val)"
                >{{ $t(`login.common.accountType.${key}`) }}</div>
              </div>
            </div>
          </div>
        </template>
      </PersonalCommonHeader>
      <template v-else>
        <div class="header-left" :class="showHolidayLogo && 'need-left-spacing'">
          <div class="company-info">
            <div class="company-logo-wrapper">
              <img class="company-logo" :src="headerCompanyLogo"/>
            </div>
          </div>
        </div>
        <div class="navigation">
          <div class="navigation-item">
            <a class="link" href="/jobseekers/">{{ $t('login.common.title.candidateIndexPage') }}</a>
          </div>
          <div class="navigation-item">
            <a class="link" href="/">{{ $t('login.common.title.indexPage') }}</a>
          </div>
          <div class="navigation-item">
            <a class="link" href="/?intelligence=1">{{ $t('login.common.title.intelligencePage') }}</a>
          </div>
          <div class="navigation-item">
            <div v-clickoutside="closeAccountTypeList" class="account-type-selector">
              <div class="account-type-container" @click="onAccountTypeLabelClick">
                <span class="account-type">{{ accountTypeLabel }}</span>
                <i class="dropdown-icon el-icon-arrow-down"></i>
              </div>
              <div v-show="showAccountTypeList" class="dropdown-list">
                <div
                  v-for="(val, key) in accountTypeList"
                  class="dropdown-item"
                  :key="key"
                  @click="onAccountTypeClick(val)"
                >{{ $t(`login.common.accountType.${key}`) }}</div>
              </div>
            </div>
          </div>
          <div class="navigation-item">
            <span class="language" @click="handleLanguageBtnClick">{{ anotherLanguageName }}</span>
          </div>
          <div class="navigation-item hotline">
            <i class="iconfont iconTelephone hotline-icon"></i>
            <div class="dropdown-container">
              <div class="hotline-list">
                <div class="detail-line">
                  <span class="line-label">{{ $t('admin.layout.header.hotline.cnUser') }}</span>
                  <span class="line-content phone">400-990-3308</span>
                </div>
                <div class="detail-line">
                  <span class="line-label">{{ $t('admin.layout.header.hotline.allUser') }}</span>
                  <span class="line-content email link">service@ajinga.com</span>
                </div>
              </div>
              <div class="dropdown-padding"></div>
              <div class="dropdown-arrow"></div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="content-container-wrapper" :class="company && 'has-company-info'">
      <div v-if="company" class="company-info-container">
        <div class="company-logo-container" :class="showContainerLogo && headerCompanyLogo && 'has-company-logo'">
          <img v-if="showContainerLogo && headerCompanyLogo" class="company-logo" :src="headerCompanyLogo"/>
        </div>
        <div class="company-name">{{ $t(`login.common.message.${isLoginPage ? 'loginCompany' : 'registerCompany'}`) }}</div>
        <div v-if="accountType !== ACCOUNT_TYPE.CANDIDATE" class="login-register-tip">
          <template v-if="isLoginPage && showRegisterLink">
            <span v-if="accountType === ACCOUNT_TYPE.EMPLOYEE">{{ $t('login.common.message.registerTip.noAccount') }}</span>
            <router-link class="register-new link" :to="{ path: registerLink, query: $route.query, hash: $route.hash }">{{ $t(`login.common.message.registerTip.${accountType === ACCOUNT_TYPE.CANDIDATE ? 'registerByEmail' : 'register'}`) }}</router-link>
          </template>
          <template v-else-if="isRegisterPage">
            <span>{{ $t('login.common.message.loginTip.hasAccount') }}</span>
            <router-link class="register-new link" :to="{path: loginLink, query: $route.query, hash: $route.hash }">{{ $t('login.common.message.loginTip.login') }}</router-link>
          </template>
        </div>
      </div>
      <div class="content">
        <div v-if="accountType === ACCOUNT_TYPE.CANDIDATE && activeLoginType" class="content-menu">
          <el-menu class="el-menu-container" mode="horizontal" :default-active="activeLoginType" @select="handleChangeLoginType">
            <el-menu-item index="register">{{ $t('login.common.label.register') }}</el-menu-item>
            <el-menu-item index="login">{{ $t('login.common.label.passwordLogin') }}</el-menu-item>
          </el-menu>
        </div>
        <router-view class="content-container" :company="company" :showOtherAccount="showOtherAccount" :linkedinLoginLink="linkedinLoginLink" :onlyShowLinkedin="onlyShowLinkedin" :customStyle="customStyle" :facebookSDKLoader="facebookSDKLoader"></router-view>
      </div>
    </div>
    <CommonFooter v-if="company?.root_company.id !== ROOT_COMPANY_ID.MERCEDES_BENZ || isPc" class="footer" :showFooterLink="isPc"></CommonFooter>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { ACCOUNT_TYPE, FACEBOOK_APP_ID } from '@/constant/common'
import _ from 'lodash'
import { addI18nProperty, isEn, switchLanguageWithZhAndEn } from '@/i18n'
import { mapActions, mapGetters } from 'vuex'
import { mixedRouterPush } from '@/router/routes'
import { deviceType } from '@/utils/common'
import { getHmToken } from '@/utils/hmToken'
import CommonFooter from '@/components/layout/footer/commonFooter.vue'
import PersonalCommonHeader from '@/components/layout/header/personalCommonHeader.vue'
import { resetPasswordRoute, createPasswordRoute, loginRoute, registerCandidateRoute, registerEmployeeRoute } from './route'
import { ROOT_COMPANY_ID } from '@/constant/company'

window.deviceType = deviceType

export default {
  directives: {
    Clickoutside
  },
  components: {
    CommonFooter,
    PersonalCommonHeader
  },
  metaInfo () {
    const isMobile = deviceType.isMobile
    const pcStyle = `
      ::-webkit-scrollbar {
        width: 18px;
        height: 18px;
        border-radius: 10px;
        background: #fafafa;
      }
      ::-webkit-scrollbar-thumb {
        border: 4px solid transparent;
        border-radius: 10px;
        background: #c3c5c9;
        background-clip: content-box;
      }
    `
    const elementStyle = `
      .el-popover.light-popper {
        color: #606266;
        font-size: 14px;
        line-height: 22px;
      }
      .el-popover.light-popper,
      .el-tooltip__popper.is-dark.light-tooltip-popper {
        border-color: #e6e6e6;
        -webkit-box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
                box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      }
      .el-popover.light-popper[x-placement] .popper__arrow,
      .el-tooltip__popper.is-dark.light-tooltip-popper[x-placement] .popper__arrow {
        border-bottom-color: #e6e6e6;
        border-top-color: #e6e6e6;
      }
      .el-popover.light-popper[x-placement] .popper__arrow::after,
      .el-tooltip__popper.is-dark.light-tooltip-popper[x-placement] .popper__arrow::after  {
        border-bottom-color: #e6e6e6;
        border-top-color: #e6e6e6;
      }
    `
    const styleList = [elementStyle]
    if (!isMobile) {
      styleList.push(pcStyle)
    }
    return {
      style: [
        {
          cssText: _.join(styleList, '')
        }
      ],
      script: this.scriptList
    }
  },
  data () {
    return {
      ACCOUNT_TYPE,
      ROOT_COMPANY_ID,
      showAccountTypeList: false,
      loading: true,
      isMobile: deviceType.isMobile,
      isPc: deviceType.isPc,
      company: null,
      countryCodeList: null,
      showChristmasLogo: false,
      showNewYearLogo: false,
      activeLoginType: null,
      linkedinLoginLink: null,
      onlyShowLinkedin: true,
      customThemeSetting: null,
      customColor: null,
      facebookSDKLoader: null,
      scriptList: null,
      customPage: {}
    }
  },
  computed: {
    ...mapGetters('company', ['companyThemeSetting']),
    accountType () {
      const route = this.$route
      return route.meta?.accountType || route.params.accountType
    },
    accountTypeList () {
      if (this.isPc) {
        return ACCOUNT_TYPE
      }
      const list = {}
      _.forEach(ACCOUNT_TYPE, (val, key) => {
        if (val === ACCOUNT_TYPE.AGENCY) {
          return
        }
        list[key] = val
      })
      return list
    },
    accountTypeLabel () {
      const key = _.findKey(ACCOUNT_TYPE, (val) => val === this.accountType)
      if (key) {
        return this.$t(`login.common.accountType.${key}`)
      }
      return ''
    },
    anotherLanguageName () {
      return isEn() ? '中文' : 'English'
    },
    isLoginPage () {
      return loginRoute.meta === this.$route.meta
    },
    isEmployeeRegisterPage () {
      return registerEmployeeRoute.meta === this.$route.meta
    },
    isCandidateRegisterPage () {
      return registerCandidateRoute.meta === this.$route.meta
    },
    isRegisterPage () {
      return this.isEmployeeRegisterPage || this.isCandidateRegisterPage
    },
    isSetPasswordPage () {
      return [createPasswordRoute.meta, resetPasswordRoute.meta].includes(this.$route.meta)
    },
    showRegisterLink () {
      if ([ACCOUNT_TYPE.CANDIDATE, ACCOUNT_TYPE.EMPLOYEE].includes(this.accountType)) {
        return true
      }
      return false
    },
    companyLogo () {
      let logo = this.company?.logo
      if (this.company?.has_referral_share) {
        logo = this.company.root_company.logo
      }
      return this.$DjangoBaseUrl(logo)
    },
    companyName () {
      let companyName = this.company?.i18nName
      if (this.company?.has_referral_share) {
        companyName = this.company.root_company.i18nName
      }
      return companyName
    },
    registerLink () {
      if ([ACCOUNT_TYPE.CANDIDATE, ACCOUNT_TYPE.EMPLOYEE].includes(this.accountType)) {
        return `/passport/${this.accountType}/register`
      }
      return '/'
    },
    loginLink () {
      if ([ACCOUNT_TYPE.CANDIDATE, ACCOUNT_TYPE.EMPLOYEE].includes(this.accountType)) {
        return `/passport/${this.accountType}/login`
      }
      return '/'
    },
    showHolidayLogo () {
      return this.showChristmasLogo || this.showNewYearLogo
    },
    holidayIconClass () {
      if (this.showChristmasLogo) {
        return 'christmas-icon'
      } else if (this.showNewYearLogo) {
        return 'new_year-icon'
      } else {
        return null
      }
    },
    holidayIcon () {
      if (this.showChristmasLogo) {
        return require('@/assets/image/holiday_logo/christmas.png')
      } else if (this.showNewYearLogo) {
        return require('@/assets/image/holiday_logo/new_year.png')
      } else {
        return null
      }
    },
    companyId () {
      return this.company?.id
    },
    applyJobId () {
      return this.$route.query.apply_job_id
    },
    showOtherAccount () {
      return [ACCOUNT_TYPE.CANDIDATE, ACCOUNT_TYPE.ALUMNI].includes(this.accountType)
    },
    hasCustomTheme () {
      return this.companyThemeSetting?.has_custom_theme
    },
    logoPosition () {
      return this.companyThemeSetting?.headerSetting?.logoPosition || 'left'
    },
    showTopAndBottomBackgroundImage () {
      return this.hasCustomTheme ? !this.companyThemeSetting.loginSetting?.backgroundColor : true
    },
    showContainerLogo () {
      return this.hasCustomTheme ? this.companyThemeSetting.loginSetting?.showContainerLogo : true
    },
    showCustomFooterNavigation () {
      const footerContent = this.companyThemeSetting?.footerSetting?.footerContent
      if (footerContent && footerContent.length > 0) {
        return true
      }
      return false
    },
    headerCompanyLogo () {
      if (this.companyThemeSetting) {
        const headerSetting = this.companyThemeSetting?.headerSetting || {}
        return headerSetting.logoImage
          ? headerSetting.logoImage.url
          : this.companyLogo
      }
      return require('@/assets/image/ajinga_logo_black.png')
    },
    customStyle () {
      const headerSetting = this.companyThemeSetting?.headerSetting || {}
      const loginSetting = this.companyThemeSetting?.loginSetting || {}
      const userMenuBackgroundColor = headerSetting.userMenu?.backgroundColor
      const userMenuFontColor = headerSetting.userMenu?.fontColor
      return {
        '--custom-menu-bottom-color': this.customColor,
        '--custom-color': loginSetting.followCustomColor ? this.customColor : null,
        '--rgb-custom-color': loginSetting.followCustomColor ? this.hexToRgb(this.customColor) : null,
        '--header-background-color': headerSetting.headerBackgroundColor,
        '--header-font-color': headerSetting.headerFontColor,
        '--header-height': headerSetting.headerHeight ? `${headerSetting.headerHeight}px` : this.hasCustomTheme ? '124px' : null,
        '--user-menu-background-color': userMenuBackgroundColor,
        '--user-menu-border-color': (userMenuBackgroundColor && _.toUpper(headerSetting.headerBackgroundColor) !== _.toUpper(userMenuBackgroundColor)) ? headerSetting.headerBackgroundColor : null,
        '--user-menu-border-radius': (userMenuBackgroundColor && _.toUpper(headerSetting.headerBackgroundColor) !== _.toUpper(userMenuBackgroundColor)) ? '4px' : null,
        '--user-menu-font-color': userMenuFontColor,
        '--logo-position': headerSetting.logoPosition,
        '--logo-width': headerSetting.logoWidth ? `${headerSetting.logoWidth}px` : this.hasCustomTheme ? '80px' : null,
        '--background-color': loginSetting.backgroundColor
      }
    }
  },
  beforeCreate () {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: FACEBOOK_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v3.1'
      })
    }
  },
  created () {
    if (!_.includes(ACCOUNT_TYPE, this.accountType)) {
      this.$router.push('/error/404.html')
      return
    }
    this.initPage()
  },
  methods: {
    ...mapActions('account', ['getLoginInfo', 'getThirdPartyLoginInfo']),
    ...mapActions('hm', ['getHmInfo', 'setToken']),
    ...mapActions('common', ['changeLanguage', 'checkHoliday']),
    ...mapActions('company', ['getCompanyBrandingPageInfo']),
    async initPage () {
      this.checkHolidayStatus()
      this.loading = true
      this.$eventBus.$emit('showLoading', true)
      let hasLogin = false
      this.loadCompanyPageInfo()
      try {
        if (this.accountType === ACCOUNT_TYPE.HIRING_MANAGER) {
          if (this.$route.query.logout) {
            this.setToken()
          }
          const nextPage = this.$route.query.back || { name: 'hm-dashboard', query: { ...this.$route.query, back: undefined } }
          if (getHmToken()) {
            try {
              await this.getHmInfo()
              hasLogin = true
              mixedRouterPush(nextPage)
              return
            } catch (error) {
              if (error.response?.status === 401) {
                this.setToken()
              } else {
                throw error
              }
            }
          }
        }
        hasLogin = await this.loadLoginInfo()
        await this.initThirdPartyLoginUrl()
      } finally {
        if (!hasLogin) {
          this.loading = false
        }
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async loadLoginInfo () {
      let hasLogin = false
      const route = this.$route
      const query = route.query
      const resp = await this.getLoginInfo({
        wx_oauth_code: query.code,
        wx_oauth_back: `${window.location.origin}${route.fullPath}`,
        back: this.getBackUrl(),
        company_id: query.company_id,
        onboarding_id: query.onboarding_id,
        is_register: this.isRegisterPage ? 1 : 0,
        is_set_password: this.isSetPasswordPage ? 1 : 0
      })

      // 临时使用的强制跳转: 登录后跳转指定页面
      const isRegisterPageNeedRedirect = resp.account &&
          this.accountType !== ACCOUNT_TYPE.HIRING_MANAGER &&
          ['cgmg5l2nrm', 'gmaauujkia'].some(item => _.includes(window.location.href, item))

      const customCheckLogin = resp.account &&
          this.accountType !== ACCOUNT_TYPE.HIRING_MANAGER &&
          !(this.isCandidateRegisterPage || (this.isEmployeeRegisterPage && !resp.account.employee?.id))

      if (resp) {
        if (resp.need_wx_auth) {
          window.location.href = resp.wx_oauth_url
          return
        } else if (isRegisterPageNeedRedirect || customCheckLogin) {
          hasLogin = true
          this.$store.commit('account/SET_CURRENT_ACCOUNT', resp.account)
          mixedRouterPush(resp.next_page)
        } else if (resp.company) {
          hasLogin = false
          const company = resp.company
          if (!this.$route.query.company_id) {
            this.$router.replace({ query: { ...this.$route.query, company_id: company.id }, hash: this.$route.hash })
          }
          addI18nProperty(company, 'i18nName', 'cn_name', 'name')
          addI18nProperty(company.root_company, 'i18nName', 'cn_name', 'name')
          company.email_suffix = _.map(company.email_suffix, (suffix) => _.toLower(suffix))

          const employeeForm = company.employee_form
          addI18nProperty(employeeForm, 'i18nEmployeeIdNumTip', 'employee_id_num_tip.cn', 'employee_id_num_tip.en')
          _.forEach(employeeForm.register_company_list, com => {
            com.name = `${com.id} - ${com.name}`
            com.cn_name = `${com.id} - ${com.cn_name}`
            addI18nProperty(com, 'i18nName', 'cn_name', 'name')
          })
          if (employeeForm.custom_policy) {
            const policy = employeeForm.custom_policy
            addI18nProperty(policy, 'i18nTip', 'tip.cn', 'tip.en')
            addI18nProperty(policy, 'i18nLabel', 'label.cn', 'label.en')
            addI18nProperty(policy, 'i18nLink', 'link.cn', 'link.en')
          }
          this.company = company
          this.customColor = this.company.custom_color
        }
        if (resp.country_code_list) {
          const countryCodeList = resp.country_code_list
          _.forEach(countryCodeList, (code) => {
            addI18nProperty(code, 'countryName', 'country_name_cn', 'country_name_en')
            code.countryCode = `+${code.country_code}`
            code.keywords = _.map([code.countryCode, code.country_name_cn, code.country_name_en], str => str.toLocaleLowerCase())
          })
          this.countryCodeList = countryCodeList
        }
      }
      return hasLogin
    },
    async loadCompanyPageInfo () {
      const companyId = this.$route.query.company_id
      if (!companyId) {
        return
      }
      const resp = await this.getCompanyBrandingPageInfo({
        company_id: companyId,
        language_code: this.$i18n.locale === 'en' ? 'en' : 'zh-cn'
      })
      if (resp) {
        const brandingPage = resp.branding_page
        const landingPage = resp.landing_page
        if (brandingPage) {
          addI18nProperty(brandingPage, 'i18nName', 'menu_cn_name', 'menu_en_name')
        }
        if (landingPage) {
          addI18nProperty(landingPage, 'i18nName', 'menu_cn_name', 'menu_en_name')
        }
        this.customPage = resp
      }
    },
    async handleChangeLanguage () {
      this.$eventBus.$emit('showLoading', true)
      try {
        await this.loadCompanyPageInfo()
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async initThirdPartyLoginUrl () {
      const resp = await this.getThirdPartyLoginInfo({
        company_id: this.companyId,
        apply_job_id: this.applyJobId
      })
      if (resp) {
        this.linkedinLoginLink = resp.linkedin_auth_url
        this.onlyShowLinkedin = resp.only_show_linkedin
        if (!this.onlyShowLinkedin) {
          this.initFacebookLogin()
        }
      }
    },
    async checkHolidayStatus () {
      const resp = await this.checkHoliday()
      if (resp) {
        this.showChristmasLogo = resp.show_christmas_logo
        this.showNewYearLogo = resp.show_new_year_logo
      }
    },
    handleLanguageBtnClick () {
      switchLanguageWithZhAndEn()
      this.changeLanguage(isEn() ? 'en' : 'zh-cn')
    },
    closeAccountTypeList () {
      this.showAccountTypeList = false
    },
    onAccountTypeLabelClick () {
      this.showAccountTypeList = !this.showAccountTypeList
    },
    onAccountTypeClick (accountType) {
      const path = `/passport/${accountType}/${accountType === ACCOUNT_TYPE.CANDIDATE ? 'register' : 'login'}`
      if (this.$route.path === path) {
        this.loading = true
        this.$nextTick(() => {
          this.loading = false
        })
      } else {
        this.$router.push({
          path,
          query: this.$route.query,
          hash: this.$route.hash
        })
      }
      this.showAccountTypeList = false
    },
    handleChangeLoginType (type) {
      if (type === this.activeLoginType) {
        return
      }
      this.activeLoginType = type
      this.$router.push({
        path: `/passport/candidate/${type}`,
        query: this.$route.query,
        hash: this.$route.hash
      })
    },
    hexToRgb (hex) {
      if (!hex) {
        return null
      }
      if (hex.startsWith('#')) {
        hex = hex.slice(1)
        const bigint = parseInt(hex, 16)
        const r = (bigint >> 16) & 255
        const g = (bigint >> 8) & 255
        const b = bigint & 255
        return `${r},${g},${b}`
      }
      return null
    },
    initFacebookLogin () {
      if (this.facebookSDKLoader) {
        return
      }
      let loaded
      this.facebookSDKLoader = new Promise((resolve) => {
        loaded = resolve
      })
      this.scriptList = [
        {
          defer: true,
          src: 'https://connect.facebook.net/en_US/sdk.js',
          callback: () => {
            loaded()
          }
        }
      ]
    },
    getBackUrl () {
      const query = this.$route.query
      return query.back ? `${query.back}${this.$route.hash}` : null
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler () {
        this.activeLoginType = this.$route.meta.loginType
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  min-width: 1100px;
  min-height: 100vh;
  padding-bottom: 80px;
  background-color: var(--background-color, #e8f9ff);
  font-size: 14px;
  line-height: 20px;
  color: #606266;
  box-sizing: border-box;
  position: relative;

  &.has-custom-footer {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }

  ::v-deep * {
    box-sizing: border-box;
  }

  .background-image {
    display: block;
    position: absolute;

    &.right-top {
      width: 100vw;
      height: calc(100vw / 180 * 47);
      background: url(~@/assets/login/right_top_bg.png) no-repeat;
      background-size: 100%;
      top: var(--header-height, 124px);
      right: 0;
    }

    &.left-bottom {
      width: 22.2vw;
      height: calc(22.2vw / 12 * 13);
      background: url(~@/assets/login/left_bottom_bg.png) no-repeat;
      background-size: 100%;
      bottom: 0;
      left: 0;
    }
  }

  .account-type-selector {
    position: relative;

    .account-type-container {
      padding: 5px 14px;
      border: 1px solid var(--user-menu-border-color, #0096cc);
      line-height: 20px;
      border-radius: var(--user-menu-border-radius, 0);
      background: var(--user-menu-background-color, null);
      cursor: pointer;

      &:hover {
        border-color: var(--user-menu-border-color, #0096cc);

        .account-type {
          color: var(--user-menu-font-color, #0096cc);
        }
      }

      .account-type {
        display: inline-block;
        width: 108px;
        font-size: 14px;
        color: var(--user-menu-font-color, #0096cc);
      }

      .dropdown-icon {
        font-size: 12px;
      }
    }

    .dropdown-list {
      width: 100%;
      margin-top: 6px;
      border: 1px solid #d8dce6;
      background: var(--user-menu-background-color, #fff);
      color: var(--user-menu-font-color, #606266);
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 1;

      .dropdown-item {
        padding: 4px 13px;
        line-height: 20px;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          background: #f0f0f0;
        }

        &.is-active {
          background: #0096cc;
          color: #ffffff;
        }
      }
    }
  }

  .company-info {

    &.has-left-navigation {
      margin-right: 20px;
    }

    .company-logo-wrapper {
      display: inline-block;
      width: 165px;
      overflow: hidden;
      vertical-align: middle;

      &.has-company-logo {
        width: var(--logo-width, 80px);
        height: var(--logo-width, 80px);
        border-radius: 50%;
      }

      .company-logo {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .company-name {
      display: inline-block;
      max-width: 250px;
      margin-left: 15px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: keep-all;
    }
  }

  .header {
    height: var(--header-height, 124px);
    line-height: var(--header-height, 124px);
    padding: 0 40px;
    color: var(--header-font-color);
    background-color: var(--header-background-color, #fff);

    &::after {
      content: '';
      display: block;
      clear: both;
      height: 0;
      visibility: hidden;
    }

    .common-header {
      padding: 0;

      .navigation-item {
        padding: 0 20px 0 21px;
        line-height: 32px;
        position: relative;

        &::before {
          content: '';
          display: block;
          width: 1px;
          position: absolute;
          left: 0;
          top: 4px;
          bottom: 4px;
          background: #dcdfe6;
        }

        &:first-child {
          padding-left: 0;

          &::before {
            display: none;
          }
        }

        &:last-child {
          padding-right: 0;
        }

        .link {
          color: var(--header-font-color, #606266);

          &:hover {
            color: var(--header-font-color, #0096cc);
          }
        }
      }

      ::v-deep {
        .navigation {
          height: 32px;
          line-height: 32px;
        }

        .menu-list {
          margin-left: 60px;
        }
      }
    }

    .header-left {
      float: left;
      height: 100%;
      display: flex;
      align-items: center;

      .navigation-link {

        .link {
          color: var(--header-font-color, #606266);
          margin-right: 20px;

          &:hover {
            color: var(--header-font-color, #0096cc);
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .need-left-spacing {
      margin-left: 20px;
    }

    .navigation {
      float: right;
      display: flex;
      height: 100%;
      align-items: center;

      .navigation-item {
        padding: 0 20px 0 21px;
        line-height: 32px;
        position: relative;

        &::before {
          content: '';
          display: block;
          width: 1px;
          position: absolute;
          left: 0;
          top: 4px;
          bottom: 4px;
          background: #dcdfe6;
        }

        &:first-child {
          padding-left: 0;

          &::before {
            display: none;
          }
        }

        &:last-child {
          padding-right: 0;
        }

        .link {
          color: var(--header-font-color, #606266);

          &:hover {
            color: var(--header-font-color, #0096cc);
          }
        }

        .language {
          cursor: pointer;
          color: var(--header-font-color, #0096cc);

          &:hover {
            color: var(--header-font-color, #00aaff);
          }
        }

        &.hotline {
          position: relative;

          .hotline-icon {
            font-size: 24px;
            cursor: pointer;
            color: #939393;

            &:hover {
              ~ .dropdown-container {
                display: block;
              }
            }
          }

          .hotline-list {
            .detail-line {
              height: 22px;
              line-height: 22px;
              word-break: keep-all;
              white-space: nowrap;

              .line-label {
                display: inline-block;
                width: 85px;
                color: #333;
              }

              .line-content {
                margin-left: 10px;
                font-size: 14px;

                &.phone {
                  color: #ff6633;
                }
                &.email{
                  text-decoration: underline;
                }
              }
            }
          }

          .dropdown-container {
            display: none;
            margin-top: 20px;
            padding: 10px 15px;
            border: 1px solid #aaa;
            border-radius: 10px;
            background: #fff;
            cursor: pointer;
            position: absolute;
            top: 100%;
            right: -18px;
            z-index: 10;

            &:hover {
              display: block;
            }

            .dropdown-arrow {
              width: 22px;
              height: 15px;
              background: url($baseDomain + 'static/image/list_assets.png?t=5') no-repeat -20px -142px;
              position: absolute;
              top: -13px;
              right: 18px;
            }

            .dropdown-padding {
              width: 35px;
              height: 30px;
              position: absolute;
              top: -30px;
              right: 14px;
            }
          }
        }
      }
    }
  }

  .has-holiday-logo {
    position: relative;
    .holiday-icon {
      position: absolute;
      left: 2px;
      top: -11px;
      width: 52px;
      z-index: 1;
    }
    .christmas-icon {
      top: calc(var(--header-height, 124px) / 2 - 22px);
    }

    .new_year-icon {
      top: calc(var(--header-height, 124px) / 2 - 28px);
    }
  }

  .content-container-wrapper {
    width: 500px;
    margin: 80px auto 40px;
    position: relative;

    &.has-company-info  {
      margin-top: 50px;

        .content-container {
          padding-top: 30px;

          ::v-deep .content-form {
            margin-top: 0;
          }
        }
    }

    .content {
      box-shadow: 0 2px 6px 0 rgba($color:  var(--rgb-custom-color, 0, 150, 204), $alpha: .12);
    }

    .company-info-container {
      text-align: center;
      padding-bottom: 24px;

      .company-logo-container {
        display: inline-block;
        min-height: 50px;
        line-height: 0;

        &.has-company-logo {
          width: 100px;
          height: 100px;
        }

        .company-logo {
          display: inline-block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.04);
        }
      }

      .company-name {
        margin-top: 22px;
        color: #303133;
        font-size: 22px;
        line-height: 30px;
      }

      .login-register-tip {

        .register-new {
          &.link {
            color: var(--custom-color, #0096cc)
          }
        }
      }
    }

    .el-menu-container {
      padding: 20px 50px 0 50px;
      display: flex;
      justify-content: center;
      border-bottom-width: 0;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;

      .el-menu-item {
        text-align: center;
        width: 50%;
        font-size: 22px;

        &.is-active {
          border-bottom-color: var(--custom-menu-bottom-color, #0096cc);
        }
      }
    }

    .content-container {
      padding: 40px 50px;
      border-radius: 6px;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba($color: var(--custom-color, #0096cc), $alpha: .12);

      ::v-deep .container-title {
        line-height: 49px;
        color: #303133;
        font-size: 35px;
        font-weight: 500;

        & + .content-form {
          margin-top: 35px;
        }
      }
    }
  }

  &.is-candidate {
    .content-container-wrapper {
      &.has-company-info {
        .content {
          .content-container {
            padding-top: 28px;
          }
        }
      }

      .content {
        box-shadow: 0 2px 6px 0 rgba($color:  var(--rgb-custom-color, 0, 150, 204), $alpha: .12);

        .content-container {
          padding-top: 2px;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          box-shadow: initial;
        }
      }
    }
  }

  .footer {
    font-size: 12px;
    line-height: 18px;
    color: #909399;
    text-align: center;
    position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: center;
    width: initial;

    ::v-deep {

      &.custom-footer {
        width: 100%;
        position: initial;
      }

      .copyright {
        color: #909399;
      }

      .navigation {
        margin-top: 5px;

        & > div {
          margin: 0 5px;
        }
      }
    }
  }

  .custom-footer {
    margin-top: auto;
  }

  &.is-mobile {
    padding-top: 40px;
    font-size: 12px;
    line-height: 18px;
    min-width: initial;

    .background-image {
      &.right-top {
        width: 134vw;
        height: calc(134vw / 180 * 47);
        top: -10px;
      }
    }

    .content-container-wrapper {
      width: auto;
      margin: 30px 0 80px;
      padding: 0 20px;

      .company-info-container {
        .company-logo-container {
          min-height: 20px;
        }

        .company-name {
          font-size: 18px;
          line-height: 26px;
        }
      }

      .el-menu-container {
        padding: 20px 25px 0 25px;
        font-size: 20px;

        .el-menu-item {
          padding: 0;
          font-size: 20px;
        }
      }

      .content-container {
        padding: 30px 25px;
      }
    }

    .account-type-selector {
      position: absolute;
      top: 10px;
      right: 10px;

      .account-type-container {
        border-radius: 0;
        border-color: var(--custom-color, #0096cc);
      }
    }
  }
}
</style>
